export const generateYTCLink = (converterLink: string) => {
  const date = new Date();
  const salt = Math.floor((date.getMonth()*30 + date.getDate())/5)*5;

  return `${converterLink}-${salt}`;
}
